export function setCustomAttribute(key, value) {
    if (window.newrelic) {
        window.newrelic.setCustomAttribute(key, value);
    }
}

/**
 * keeping separate functions for setting some common attributes like user_id, client_id etc.
 * because there is a possibility that someone might use "UserID" or something else instead of "user_id".
*/
export function setUserId(id) {
    setCustomAttribute('user_id', id);
}

export function setClientId(id) {
    setCustomAttribute('client_id', id);
}

export function setAspitUserId(id) {
    setCustomAttribute('aspit_user_id', id);
}

export function setErrorHandler(app) {
    if (ENV === 'production' && window.newrelic) {
        // This won't log the frontend errors in the user's browser's console in production.
        app.config.errorHandler = function (err, vm, info) {
            window.newrelic.noticeError(err);
        };
    }
}

// debugging purpose for certain users
// todo: EPI-1058 -> remove when ticket is closed
const userIdsToMonitor = [56433, 53973, 63187];

// we can keep this function for debugging purpose.
export function logDataForDebugging(message, data) {
    if (userIdsToMonitor.includes(window?.user_id) && window.newrelic && data && message) {
        window.newrelic.noticeError(message, data);
    }
}

export function logError(error) {
    if (userIdsToMonitor.includes(window?.user_id) && window.newrelic) {
        window.newrelic.noticeError(error);
    }
}
